/**
 * Different modes of the content editor
 */
export enum ContentEditorModeEnum {
  text = 'TEXT',
  pdf = 'PDF'
}
